/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Modal from "react-modal";
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { doc, setDoc } from "firebase/firestore";
import "./Try.css";
import Table from "../../components/table/Table";
import { db } from "../../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { useTranslation } from "react-i18next";


import "bootstrap/dist/css/bootstrap.min.css";
import {
  setActiveFilter,
  setCopied,
  clearError,
  shareAffiliateLink,
} from "../../redux/affiliate/affiliate";

function Try({ handleCloseModal }) {
  const { t, i18n } = useTranslation();
  const dir = i18n.dir();
  const dispatch = useDispatch();
  const account = useSelector((state) => state.AccountReducer);
  const {
    referralLink,
    loadingAccounts,
    activeFilter,
    copied,
  } = useSelector((state) => state.affiliate);

  const [showSideBar, setShowSideBar] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [signUpLink, setSignUpLink] = useState("");

  const [newCallNameInput, setNewCallNameInput] = useState("");
  const [addCallNameModal, setAddCallNameModal] = useState(false);
  const [isModalOpenPoints, setIsModalOpenPoints] = useState(false);
  const [isModalOpenQuestions, setIsModalOpenQuestions] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [allAccounts, setAllAccounts] = useState([]);
  const [allTransactions, setAllTransactions] = useState([]);
  const [paidAccounts, setPaidAccounts] = useState([]);
  const [unpaidAccounts, setUnpaidAccounts] = useState([]);

  useEffect(() => {
    const fetchAccountsAndTransactions = async () => {
      if (!account?.user) return;
      console.log(account)

      try {
        const accountsQuery = query(
          collection(db, "account"),
          where("invitedBy", "==", account?.user)
        );
        const accountsSnapshot = await getDocs(accountsQuery);
        const accounts = accountsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setAllAccounts(accounts);

        const transactionsQuery = query(
          collection(db, "transaction"),
          where("userInvitedBy", "==", account?.user)
        );
        const transactionsSnapshot = await getDocs(transactionsQuery);
        const transactions = transactionsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setAllTransactions(transactions);

        const paid = [];
        const unpaid = [];

        accounts.forEach(acc => {
          const matchingTransaction = transactions.find(tx => tx.user === acc.user);
          if (matchingTransaction) {
            paid.push({
              ...acc,
              points: matchingTransaction.points ?? 0,
            });
          } else {
            unpaid.push({
              ...acc,
            });
          }
        });

        setPaidAccounts(paid);
        setUnpaidAccounts(unpaid);

      } catch (error) {
        console.error("Erreur lors du fetch:", error);
        alert(error);
      }
    };

    fetchAccountsAndTransactions();
  }, [account?.user]);

  useEffect(() => {
    function handleResize() {
      setShowSideBar(window.innerWidth > 576);
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (account?.callName) {
      const baseUrl = window.location.origin;
      setSignUpLink(
        `${baseUrl}/sign-up?ref=${encodeURIComponent(account?.callName)}`
      );
    }
  }, [account?.callName]);

  const handleChange = async (event) => {
    setNewCallNameInput(event.target.value);
    setError("");
    const res = await fetch(
      "https://backend.foorweb.store/api/getAccountWithCallName",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ callName: event.target.value }),
      }
    );
    const exists = res.ok;
    if (exists) {
      setError(t("navbar.try.usernameExists"));
      return;
    }
  };

  const handleCopyCallName = () => {
    if (account?.callName) {
      const tempInput = document.createElement("input");
      document.body.appendChild(tempInput);
      tempInput.value = account?.callName;
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);

      dispatch(setCopied("callName", true));
      setTimeout(() => dispatch(setCopied("callName", false)), 3000);

      Swal.fire({
        icon: "success",
        title: t("navbar.try.usernameCopied"),
        text: t("navbar.try.usernameCopiedText"),
        confirmButtonText: t("navbar.try.close"),
        confirmButtonColor: "#7e5395",
        timer: 3000,
        timerProgressBar: true,
        position: "bottom-end",
        toast: true,
        showConfirmButton: false,
      });
    }
  };

  const handleCopySignUpLink = async () => {
    if (account?.callName) {
      try {
        const tempInput = document.createElement("input");
        document.body.appendChild(tempInput);
        tempInput.value = signUpLink;
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);

        dispatch(setCopied("signUpLink", true));
        setTimeout(() => dispatch(setCopied("signUpLink", false)), 3000);

        Swal.fire({
          icon: "success",
          title: t("navbar.try.linkCopied"),
          text: t("navbar.try.linkCopiedText"),
          confirmButtonText: t("navbar.try.close"),
          confirmButtonColor: "#7e5395",
          timer: 3000,
          timerProgressBar: true,
          position: "bottom-end",
          toast: true,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error("Error copying sign-up link:", error);
        Swal.fire({
          icon: "error",
          title: t("navbar.try.error"),
          text: t("navbar.try.errorText"),
          confirmButtonText: t("navbar.try.close"),
          confirmButtonColor: "#7e5395",
        });
      }
    }
  };

  const handleShare = (platform) => {
    if (account?.callName) {
      const shareLink = signUpLink || referralLink;
      const message = t("navbar.try.shareMessage", { shareLink });
      return shareAffiliateLink(platform, shareLink, message);
    }
  };

  const handleOpenAddCallNameModal = () => setAddCallNameModal(true);

  const handleCloseAddCallNameModal = () => {
    setAddCallNameModal(false);
    setNewCallNameInput("");
    dispatch(clearError());
  };

  const handleSubmitAddCallName = async () => {
    if (!account?.id) {
      console.error("User ID is missing!");
      return;
    }

    if (!newCallNameInput.trim()) {
      Swal.fire({
        icon: "error",
        title: t("navbar.try.error"),
        text: t("navbar.try.usernameRequired"),
        confirmButtonText: t("navbar.try.close"),
        confirmButtonColor: "#7e5395",
      });
      return;
    }
    setLoading(true);
    setError("");
    try {
      await setDoc(
        doc(db, "account", account?.id),
        {
          callName: newCallNameInput,
        },
        { merge: true }
      );

      Swal.fire({
        icon: "success",
        title: t("navbar.try.savedSuccessfully"),
        confirmButtonText: t("navbar.try.close"),
        confirmButtonColor: "#7e5395",
      });

      setAddCallNameModal(false);
    } catch (error) {
      setError(error.message);
      console.error("Error saving call name:", error);
      Swal.fire({
        icon: "error",
        title: t("navbar.try.error"),
        text: t("navbar.try.saveError"),
        confirmButtonColor: "#7e5395",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModalPoints = () => setIsModalOpenPoints(true);
  const handleCloseModalPoints = () => setIsModalOpenPoints(false);

  const handleOpenModalQuestions = () => setIsModalOpenQuestions(true);
  const handleCloseModalQuestions = () => setIsModalOpenQuestions(false);

  const handleOpenShareModal = () => setIsShareModalOpen(true);
  const handleCloseShareModal = () => setIsShareModalOpen(false);

  return (
    <div className="flexColModal">
      <div className="class50 w-full flex  items-center px-4 py-3 bg-gradient-to-l shadow-md border-b dark:!border-[#3c3a3d] bg-[#a070b9] dark:bg-[#7e5395]">
        <span className="text-xl font-bold text-white">{t("navbar.try.ordersPoints")}</span>
      </div>

      <div className="modalContent max-h-[90vh] bg-white dark:!bg-[#181919] rounded-b-lg shadow-xl overflow-y-auto dark:!border-[#3c3a3d]">
        <div className="bg-white dark:!bg-[#181919] bg-opacity-90 py-3 px-4 border-x border-purple-200 dark:!border-[#3c3a3d]">
          <p className="subtitle text-base text-center text-gray-600 font-medium">
            {t("navbar.try.text1")}
            <span className="block text-sm text-gray-500 mt-1">
              {t("navbar.try.text2")}
            </span>
          </p>
        </div>

        <div className="mx-4 my-5">
          <div className="flex items-center justify-between bg-white dark:!bg-[#181919] rounded-lg py-4 px-4 border border-purple-200 dark:!border-[#3c3a3d] shadow-sm hover:shadow-md transition-shadow duration-300">
            {account?.callName ? (
              <button
                className="text-gray-500 hover:text-[#9e68ba] transition-colors duration-200"
                onClick={handleCopyCallName}
                title={t("navbar.try.copyUsername")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#7e5395"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-copy transition-transform duration-200 hover:scale-110"
                >
                  <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
                  <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1 0-2 2-2h10c1.1 0 2 .9 2 2" />
                </svg>
              </button>
            ) : (
              <button
                onClick={handleSubmitAddCallName}
                className="text-gray-500 hover:text-[#9e68ba] transition-colors duration-200"
                title={t("navbar.try.saveUsername")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#7e5395"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-save transition-transform duration-200 hover:scale-110"
                >
                  <path d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
                  <path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7" />
                  <path d="M7 3v4a1 1 0 0 0 1 1h7" />
                </svg>
              </button>
            )}

            <span className="font-semibold text-[#9e68ba] tracking-wider flex-grow text-center mx-4">
              <div>
                {account?.callName ? (
                  <div className="flex items-center justify-center gap-4">
                    <span className="text-[#7e5395] font-bold text-xl">
                      {account?.callName}
                    </span>
                  </div>
                ) : (
                  <div>
                    <input
                      className="px-3 py-2 text-gray-700 dark:text-gray-300 bg-[#fcf6ff] dark:!bg-[#3c3a3d] outline-none border border-purple-200 dark:!border-[#3c3a3d] dark:!border-[#3c3a3d] focus:border-purple-500 focus:ring-2 focus:ring-purple-200 text-center rounded-lg w-full transition-all duration-200"
                      type="text"
                      placeholder={t("navbar.try.usernameExample")}
                      value={newCallNameInput}
                      onChange={handleChange}
                    />
                    {error && (
                      <div className="text-red-500 text-sm mt-2 bg-red-50 p-1 rounded">
                        {error}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </span>

            <button
              className={`text-gray-500 hover:text-[#9e68ba] transition-colors duration-200 ${!account?.callName
                ? "opacity-50 cursor-not-allowed"
                : "hover:scale-110 transition-transform duration-200"
                }`}
              onClick={handleOpenShareModal}
              title={t("navbar.try.shareLink")}
              disabled={!account?.callName}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#7e5395"
                strokeWidth="2.25"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-share"
              >
                <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                <polyline points="16 6 12 2 8 6" />
                <line x1="12" x2="12" y1="2" y2="15" />
              </svg>
            </button>

            {copied.callName && (
              <span className="absolute top-[-40px] text-sm bg-black text-white px-3 py-2 rounded-md shadow-lg opacity-90 transform transition-all duration-300 scale-100">
                {t("navbar.try.copyNotification")}
              </span>
            )}
          </div>
        </div>

        <div className="flex items-center justify-center gap-x-8 text-gray-400 mt-6 bg-white dark:!bg-[#181919] py-4 rounded-lg shadow-sm mx-4 border border-[#fbf4ff] dark:!border-[#3c3a3d] dark:!border-[#3c3a3d]">
          <a
            href="javascript:void(0)"
            onClick={() => handleShare("facebook")}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-blue-50 dark:bg-[#3c3a3d] hover:bg-blue-100 transition-colors duration-200"
          >
            <svg
              className="w-6 h-6 text-blue-600 hover:scale-110 transition-transform duration-200"
              fill="currentColor"
              viewBox="0 0 48 48"
            >
              <g clipPath="url(#a)">
                <path d="M48 24C48 10.745 37.255 0 24 0S0 10.745 0 24c0 11.979 8.776 21.908 20.25 23.708v-16.77h-6.094V24h6.094v-5.288c0-6.014 3.583-9.337 9.065-9.337 2.625 0 5.372.469 5.372.469v5.906h-3.026c-2.981 0-3.911 1.85-3.911 3.75V24h6.656l-1.064 6.938H27.75v16.77C39.224 45.908 48 35.978 48 24z" />
              </g>
              <defs>
                <clipPath id="a">
                  <path fill="#fff" d="M0 0h48v48H0z" />
                </clipPath>
              </defs>
            </svg>
          </a>
          <a
            href="javascript:void(0)"
            onClick={() => handleShare("messenger")}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-blue-50 dark:bg-[#3c3a3d] hover:bg-blue-100 transition-colors duration-200"
          >
            <svg
              className="w-6 h-6 text-blue-500 hover:scale-110 transition-transform duration-200"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M12 2C6.36 2 2 6.13 2 11.7c0 2.91 1.19 5.44 3.14 7.17.16.13.26.35.27.57l.05 1.78c.04.57.61.94 1.13.71l1.98-.87c.17-.07.36-.06.53.03.9.44 1.88.68 2.9.68 5.64 0 10-4.13 10-9.7S17.64 2 12 2zm6 7.46-2.93 4.67c-.47.75-1.47.94-2.17.4l-2.34-1.73c-.23-.17-.54-.17-.78 0l-3.16 2.4c-.46.36-1.08-.11-.81-.62l2.92-4.67c.47-.75 1.47-.94 2.17-.4l2.34 1.73c.23.17.54.17.78 0l3.16-2.4c.46-.36 1.08.11.82.62z" />
            </svg>
          </a>
          <a
            href="javascript:void(0)"
            onClick={() => handleShare("whatsapp")}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-green-50 dark:bg-[#3c3a3d] hover:bg-green-100 transition-colors duration-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6 text-green-600 hover:scale-110 transition-transform duration-200"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
            </svg>
          </a>
          <a
            href="javascript:void(0)"
            onClick={() => handleShare("tiktok")}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-50 dark:bg-[#3c3a3d] hover:bg-gray-100 transition-colors duration-200"
          >
            <svg
              className="w-6 h-6 text-black hover:scale-110 transition-transform duration-200"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
            </svg>
          </a>
        </div>

        <div className="flexColModal mt-8 font-semibold bg-white dark:!bg-[#181919] rounded-lg shadow-md py-6 px-4 mx-4 border border-[#fbf4ff] dark:!border-[#3c3a3d] dark:!border-[#3c3a3d]">
          <span className="text-lg text-[#9e68ba]">{t("navbar.try.currentLoyaltyPoints")}</span>
          <h4 className="text-6xl mt-4 text-[#a070b9] font-bold">
            {account?.currentPoints ?? 0}
          </h4>
          <div className="text-sm text-[#7e489a] mt-2">
            {t("navbar.try.pointsUsageHint")}
          </div>
        </div>

        <div className="flexModalRow gap-4 mt-6 mx-4 mb-8">
          <button
            className="flex-1 bg-[#7e489a] hover:bg-[#9b59bf]  text-white py-3 px-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 font-medium text-base"
            onClick={handleOpenModalPoints}
          >
            {t("navbar.try.pointsRecord")}
          </button>
          <button
            className="flex-1 bg-gray-100 dark:!bg-[#3c3a3d] dark:text-gray-300 hover:bg-gray-200 text-[#9e68ba] py-3 px-6 rounded-lg shadow-sm hover:shadow-md transition-all duration-200 font-medium text-base border border-purple-200 dark:!border-[#3c3a3d]"
            onClick={handleOpenModalQuestions}
          >
            {t("navbar.try.faq")}
          </button>
        </div>
        <div className="bg-gray-50 dark:!bg-[#181919] px-6 py-4 border-t border-gray-200 dark:!border-[#3c3a3d] dark:!border-[#3c3a3d] flex justify-end w-full">
          <button
            className="text-gray-600 dark:text-gray-300 hover:text-gray-900 bg-white dark:!bg-[#141414] border border-gray-300 dark:!border-[#3c3a3d] dark:!border-[#3c3a3d] hover:bg-gray-50 font-medium py-2 px-4 rounded-lg transition-colors duration-200 flex items-center gap-2"
            onClick={handleCloseModal}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
            {t("navbar.try.close")}
          </button>
        </div>
      </div>

      {/* Share Referral Link Modal */}
      <Modal
        isOpen={isShareModalOpen}
        onRequestClose={handleCloseShareModal}
        className="selectedServiceModalTable w-[90%] md:w-[800px] max-w-[800px] mx-auto"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 999999,
          },
          content: {
            border: "none",
            borderRadius: "8px",
            padding: 0,
            margin: "0 auto",
          },
        }}
      >
        <div className="class50 w-full flex items-center px-4 py-3 bg-[#a070b9]">
          <span className="text-xl font-bold text-white">
            {t("navbar.try.shareReferralLink")}
          </span>
        </div>
        <div className="modalContent max-h-[90vh] bg-white dark:!bg-[#181919] shadow-xl overflow-y-auto">
          <div className="p-6 flex flex-col items-center">
            <h3 className="font-bold text-lg text-[#9e68ba] mb-5">
              {t("navbar.try.yourReferralLink")}
            </h3>

            <div className="w-full space-y-6">
              <div className="space-y-2">
                <p className="text-sm font-medium mb-2 text-gray-700 dark:text-gray-300 flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-2 text-[#9e68ba]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                    />
                  </svg>
                  {t("navbar.try.registrationPageLink")}
                </p>
                <div className="flex items-center bg-gray-50 dark:text-gray-300 dark:!bg-[#141414] p-3 rounded-lg border border-[#fbf4ff] hover:border-purple-300 dark:!border-[#3c3a3d] transition-colors duration-200 shadow-sm">
                  <input
                    type="text"
                    value={signUpLink}
                    readOnly
                    className="bg-transparent flex-grow text-sm outline-none text-gray-700 font-medium dark:text-gray-300"
                  />
                  <button
                    onClick={handleCopySignUpLink}
                    className="mr-2 text-[#9e68ba] hover:text-[#9e68ba] bg-[#fcf6ff] dark:bg-[#141414] hover:bg-purple-100 p-2 rounded-md transition-all duration-200"
                    title={copied.signUpLink ? t("navbar.try.copyNotification") : t("navbar.try.copyLink")}
                  >
                    {copied.signUpLink ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="text-green-600"
                      >
                        <path d="M20 6 9 17l-5-5" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect
                          width="14"
                          height="14"
                          x="8"
                          y="8"
                          rx="2"
                          ry="2"
                        />
                        <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1 0-2 2-2h10c1.1 0 2 .9 2 2" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              <div className="space-y-2">
                <p className="text-sm font-medium mb-2 text-gray-700 dark:text-gray-300 flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-2 text-[#9e68ba]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                  {t("navbar.try.yourUsername")}
                </p>
                <div className="flex items-center bg-gray-50 dark:!bg-[#141414] p-3 rounded-lg border border-[#fbf4ff] hover:border-purple-300 dark:!border-[#3c3a3d] transition-colors duration-200 shadow-sm">
                  <input
                    type="text"
                    value={account?.callName}
                    readOnly
                    className="bg-transparent flex-grow text-sm outline-none text-gray-700 dark:bg-[#141414] font-medium dark:text-gray-300"
                  />
                  <button
                    onClick={handleCopyCallName}
                    className="mr-2 text-[#9e68ba] dark:!bg-[#141414] hover:text-[#9e68ba] bg-[#fcf6ff] hover:bg-purple-100 p-2 rounded-md transition-all duration-200"
                    title={copied.callName ? t("navbar.try.copyNotification") : t("navbar.try.copyUsername")}
                  >
                    {copied.callName ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="text-green-600"
                      >
                        <path d="M20 6 9 17l-5-5" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect
                          width="14"
                          height="14"
                          x="8"
                          y="8"
                          rx="2"
                          ry="2"
                        />
                        <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1 0-2 2-2h10c1.1 0 2 .9 2 2" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              <div className="pt-4 border-t border-gray-100 dark:!border-[#3c3a3d]">
                <h4 className="font-semibold text-gray-700 dark:text-gray-300 mb-3 flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-2 text-[#9e68ba]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
                    />
                  </svg>
                  {t("navbar.try.shareVia")}
                </h4>
                <div className="grid grid-cols-2 gap-4">
                  <button
                    onClick={() => handleShare("facebook")}
                    className="flex items-center justify-center gap-2 bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 transition-colors duration-200 shadow-sm hover:shadow-md"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                    <span className="font-medium">{t("navbar.try.facebook")}</span>
                  </button>

                  <button
                    onClick={() => handleShare("messenger")}
                    className="flex items-center justify-center gap-2 bg-blue-400 text-white py-3 px-4 rounded-lg hover:bg-blue-500 transition-colors duration-200 shadow-sm hover:shadow-md"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M12 2C6.36 2 2 6.13 2 11.7c0 2.91 1.19 5.44 3.14 7.17.16.13.26.35.27.57l.05 1.78c.04.57.61.94 1.13.71l1.98-.87c.17-.07.36-.06.53.03.9.44 1.88.68 2.9.68 5.64 0 10-4.13 10-9.7S17.64 2 12 2zm6 7.46-2.93 4.67c-.47.75-1.47.94-2.17.4l-2.34-1.73c-.23-.17-.54-.17-.78 0l-3.16 2.4c-.46.36-1.08-.11-.81-.62l2.92-4.67c.47-.75 1.47-.94 2.17-.4l2.34 1.73c.23.17.54.17.78 0l3.16-2.4c.46-.36 1.08.11.82.62z" />
                    </svg>
                    <span className="font-medium">{t("navbar.try.messenger")}</span>
                  </button>

                  <button
                    onClick={() => handleShare("whatsapp")}
                    className="flex items-center justify-center gap-2 bg-green-500 text-white py-3 px-4 rounded-lg hover:bg-green-600 transition-colors duration-200 shadow-sm hover:shadow-md"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.521-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                    </svg>
                    <span className="font-medium">{t("navbar.try.whatsapp")}</span>
                  </button>

                  <button
                    onClick={() => handleShare("tiktok")}
                    className="flex items-center justify-center gap-2 bg-black text-white py-3 px-4 rounded-lg hover:bg-gray-900 transition-colors duration-200 shadow-sm hover:shadow-md"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                    </svg>
                    <span className="font-medium">{t("navbar.try.tiktok")}</span>
                  </button>
                </div>
              </div>

              <div className="mt-6">
                <div className="bg-[#fcf6ff] dark:bg-[#141414] border border-[#fbf4ff] dark:!border-[#3c3a3d] p-4 rounded-lg mb-4 text-center">
                  <p className="text-[#9e68ba] font-medium">
                    {t("navbar.try.shareHint")}
                  </p>
                </div>
                <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg shadow-sm dark:bg-[#2b2b1f] dark:!border-[#3c3a3d]">
                  <div className="flex">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-yellow-500 ml-2 flex-shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <p className="text-sm text-yellow-800 dark:text-yellow-50">
                      <strong className="font-bold">{t("navbar.try.tip")}:</strong> {t("navbar.try.shareTip")}
                    </p>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div className="bg-gray-50 dark:bg-[#141414] px-6 py-4 border-t border-gray-200 dark:border-[#3c3a3d] flex justify-between items-center">
            <button
              className="text-gray-500 dark:text-gray-300 border dark:!border-[#3c3a3d] hover:text-gray-700 cursor-pointer px-4 py-2 rounded-md hover:bg-gray-100 transition-colors duration-200 font-medium"
              onClick={handleCloseShareModal}
            >
              {t("navbar.try.close")}
            </button>

            <span className="text-xs text-gray-500 dark:text-gray-300">
              {t("navbar.try.moreShares")}
            </span>
          </div>
        </div>
      </Modal>

      {/* Points Modal */}
      <Modal
        isOpen={isModalOpenPoints}
        onRequestClose={handleCloseModalPoints}
        className="addNewModalTable2 w-[90%] md:w-[800px] max-w-[800px] mx-auto"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 999999,
          },
          content: {
            border: "none",
            borderRadius: "8px",
            padding: 0,
            margin: "0 auto",
          },
        }}
      >
        <div className="class50 w-full flex items-center px-4 py-3 bg-gradient-to-l shadow-md border-b bg-[#a070b9]">
          <span className="text-xl font-bold text-white">{t("navbar.try.loyaltyPointsRecord")}</span>
        </div>
        <div className="modalContent max-h-[90vh] bg-white dark:!bg-[#181919] shadow-xl overflow-y-auto">
          <div className="p-6"  >
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-white dark:!bg-[#181919] rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d] overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="bg-[#fcf6ff] dark:!bg-[#141414] px-4 py-3 border-b border-[#fbf4ff] dark:!border-[#3c3a3d]">
                  <h3 className="text-center text-[#9e68ba] font-bold text-lg">
                    {t("navbar.try.allPoints")}
                  </h3>
                </div>
                <div className="p-4 text-center dark:!bg-[#181919]">
                  <div className="text-4xl font-bold text-[#9e68ba] my-2">
                    {Number((account?.points ?? 0) + (account?.consumedPoints ?? 0)) || 0}
                  </div>
                  <div className="text-sm text-gray-600 dark:!text-gray-300">
                    {t("navbar.try.totalPointsEarned")}
                  </div>
                </div>
              </div>

              <div className="bg-white dark:!bg-[#181919] rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d] overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="bg-[#fcf6ff] dark:!bg-[#141414] px-4 py-3 border-b border-[#fbf4ff] dark:!border-[#3c3a3d]">
                  <h3 className="text-center text-[#9e68ba] font-bold text-lg">
                    {t("navbar.try.usedPoints")}
                  </h3>
                </div>
                <div className="p-4 text-center dark:!bg-[#181919]">
                  <div className="text-4xl font-bold text-[#9e68ba] my-2">
                    {account?.consumedPoints ?? 0}
                  </div>
                  <div className="text-sm text-gray-600 dark:!text-gray-300">
                    {t("navbar.try.previouslyUsedPoints")}
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d] overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="bg-[#fcf6ff] dark:!bg-[#141414] px-4 py-3 border-b border-[#fbf4ff] dark:!border-[#3c3a3d]">
                  <h3 className="text-center text-[#9e68ba] font-bold text-lg">
                    {t("navbar.try.remainingPoints")}
                  </h3>
                </div>
                <div className="p-4 text-center dark:!bg-[#181919]">
                  <div className="text-4xl font-bold text-[#9e68ba] my-2">
                    {account?.allPoints ?? 0}
                  </div>
                  <div className="text-sm text-gray-600 dark:!text-gray-300">
                    {t("navbar.try.yourAvailablePoints")}
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-3 justify-center mt-8 mb-6">
              <button
                onClick={() => dispatch(setActiveFilter("All"))}
                className={`border px-5 py-2 rounded-full dark:!border-[#3c3a3d] font-medium flex items-center gap-2 transition-all duration-200 ${activeFilter === "All"
                  ? "bg-[#9b59bf] text-white shadow-md"
                  : "bg-gray-100 text-gray-700 dark:!bg-[#141414] hover:bg-gray-200 dark:text-gray-300"
                  }`}
              >
                <span>{t("navbar.try.all")}</span>
                <span
                  className={`h-6 w-6 flex items-center justify-center rounded-full text-sm ${activeFilter === "All" ? "bg-purple-500" : "bg-gray-200 dark:!bg-[#181919]"
                    }`}
                >
                  {allAccounts.length}
                </span>
              </button>

              <button
                onClick={() => dispatch(setActiveFilter("Paid"))}
                className={`border dark:!border-[#3c3a3d] px-5 py-2 rounded-full font-medium flex items-center gap-2 transition-all duration-200 ${activeFilter === "Paid"
                  ? "bg-green-600 text-white shadow-md"
                  : "bg-gray-100 text-gray-700 dark:!bg-[#141414] hover:bg-gray-200 dark:text-gray-300"
                  }`}
              >
                <span>{t("navbar.try.paid")}</span>
                <span
                  className={`h-6 w-6 flex items-center justify-center rounded-full text-sm ${activeFilter === "Paid" ? "bg-green-500" : "bg-gray-200 dark:!bg-[#181919]"
                    }`}
                >
                  {paidAccounts.length}
                </span>
              </button>

              <button
                onClick={() => dispatch(setActiveFilter("UnPaid"))}
                className={`border dark:!border-[#3c3a3d] px-5 py-2 rounded-full font-medium flex items-center gap-2 transition-all duration-200 ${activeFilter === "UnPaid"
                  ? "bg-orange-600 text-white shadow-md"
                  : "bg-gray-100 dark:!bg-[#141414] text-gray-700 dark:text-gray-300 hover:bg-gray-200"
                  }`}
              >
                <span>{t("navbar.try.unpaid")}</span>
                <span
                  className={`h-6 w-6 flex items-center justify-center rounded-full text-sm ${activeFilter === "UnPaid" ? "bg-orange-500" : "bg-gray-200 dark:!bg-[#181919]"
                    }`}
                >
                  {unpaidAccounts.length}
                </span>
              </button>
            </div>

            {loadingAccounts ? (
              <div className="border border-gray-200 rounded-lg overflow-hidden shadow-sm">
                <div className="flex justify-center items-center py-20">
                  <div className="flex flex-col items-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-700 mb-4"></div>
                    <p className="text-gray-500">{t("navbar.try.loadingData")}</p>
                  </div>
                </div>
              </div>
            ) : (
              <>
                {activeFilter === "All" && (
                  <Table
                    Accounts={allAccounts}
                    loading={loadingAccounts}
                    typeData="all"
                  />
                )}
                {activeFilter === "Paid" && (
                  <Table
                    Accounts={paidAccounts}
                    loading={loadingAccounts}
                    typeData="paid"
                  />
                )}
                {activeFilter === "UnPaid" && (
                  <Table Accounts={unpaidAccounts} loading={loadingAccounts} />
                )}
              </>
            )}
          </div>

          <div className="bg-gray-50 dark:!bg-[#141414] px-6 py-4 border-t border-gray-200 dark:!border-[#3c3a3d] flex justify-between items-center">
            <button
              className="text-gray-600 hover:text-gray-900 bg-white dark:!bg-[#181919] dark:!text-gray-300 border border-gray-300 dark:!border-[#3c3a3d] hover:bg-gray-50 font-medium py-2 px-4 rounded-lg transition-colors duration-200 flex items-center gap-2"
              onClick={handleCloseModalPoints}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
              {t("navbar.try.close")}
            </button>

            <div className="text-sm text-gray-500">
              <span className="ml-2 dark:!text-gray-300">{t("navbar.try.totalInvitedPeople")}</span>
              <span className="font-medium text-[#9e68ba]">
                {allAccounts.length}
              </span>
            </div>
          </div>
        </div>
      </Modal>

      {/* Questions Modal */}
      <Modal
        isOpen={isModalOpenQuestions}
        onRequestClose={handleCloseModalQuestions}
        className="selectedServiceModalTable w-[90%] md:w-[800px] max-w-[800px] mx-auto"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 999999,
          },
          content: {
            border: "none",
            borderRadius: "8px",
            padding: 0,
            margin: "0 auto",
            direction: dir, // Appliquer la direction ici aussi si nécessaire
          },
        }}
      >
        <div className="w-full flex justify-end items-center px-4 py-3 bg-gradient-to-l bg-[#a070b9] to-purple-700 shadow-md">
          <span className="text-xl font-bold text-white">
            {t("navbar.try.couponDetails")}
          </span>
        </div>

        <div className="bg-white dark:!bg-[#181919] max-h-[90vh] rounded-lg shadow-xl overflow-y-auto">
          <div className="p-6 space-y-6" dir={dir}>
            {/* Les étapes (1 à 4) */}
            <div className="bg-[#fcf6ff] dark:!bg-[#141414] p-5 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d] ">
              <h3 className="text-lg font-bold text-[#9e68ba] mb-4 flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={`h-6 w-6 ${dir === "rtl" ? "ml-2" : "mr-2"} text-[#9e68ba]`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                  />
                </svg>
                {t("navbar.try.howToUse")}
              </h3>

              {[1, 2, 3, 4].map((step) => (
                <div className="flex" key={step}>
                  <div
                    className={`flex-shrink-0 h-6 w-6 rounded-full bg-[#efd3ff] dark:bg-[#2a2a2a] text-[#9e68ba] dark:text-[#d2a8ff] flex items-center justify-center font-bold text-sm pt-1 ${dir === "rtl" ? "ml-3" : "mr-3"}`}
                  >
                    {step}
                  </div>
                  <p className="text-[#9e68ba] dark:text-[#d2a8ff]">
                    {t(`navbar.try.step${step}`)}
                  </p>
                </div>

              ))}
            </div>

            {/* Exemple et note */}
            <div className="bg-white border border-[#fbf4ff] dark:!bg-[#141414] rounded-lg p-5 dark:!border-[#3c3a3d]">
              <div className="bg-red-50 dark:bg-red-500 py-2 px-3 rounded-md inline-block mb-3">
                <p className="text-red-600 dark:text-red-200 text-sm font-medium">
                  {t("navbar.try.newStoresOnly")}
                </p>
              </div>

              <div className="bg-gray-50 dark:bg-[#141414] p-4 rounded-md border border-gray-200 dark:!border-[#3c3a3d] ">
                <h4 className="font-bold text-gray-700 mb-2 dark:text-white">{t("navbar.try.example")}</h4>
                <p className="text-gray-700 dark:text-gray-300 text-sm leading-relaxed">
                  {t("navbar.try.exampleText")}
                </p>
              </div>
            </div>

            {/* FAQ */}
            <div>
              <h3 className="text-lg font-bold text-[#9e68ba] dark:!text-white mb-4 flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={`h-6 w-6 ${dir === "rtl" ? "ml-2" : "mr-2"} text-[#9e68ba]`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                {t("navbar.try.faqTitle")}
              </h3>

              {[1, 2, 3, 4, 5, 6, 7].map((num) => (
                <div key={num} className="rounded-lg border border-gray-200 dark:!border-[#3c3a3d] overflow-hidden mb-2">
                  <div className="bg-gray-50 dark:!bg-[#181919] px-4 py-3 border-b border-gray-200 dark:!border-[#3c3a3d]">
                    <h5 className="font-bold text-gray-800 dark:!text-white">
                      {t(`navbar.try.q${num}`)}
                    </h5>
                  </div>
                  <div className="px-4 py-3">
                    <p className="text-gray-700 dark:!text-gray-300">{t(`navbar.try.a${num}`)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Footer */}
          <div className="bg-gray-50 dark:!bg-[#181919] px-6 py-4 border-t border-gray-200 dark:border-[#3c3a3d] flex justify-between items-center">
            <button
              className="text-gray-600 dark:text-gray-300 hover:text-gray-900 bg-white dark:!bg-[#141414] border border-gray-300 dark:!border-[#3c3a3d] hover:bg-gray-50 font-medium py-2 px-4 rounded-lg transition-colors duration-200 flex items-center gap-2"
              onClick={handleCloseModalQuestions}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
              {t("navbar.try.close")}
            </button>

            <div className="flex items-center text-sm text-gray-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`h-5 w-5 text-[#9e68ba] ${dir === "rtl" ? "ml-1" : "mr-1"}`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span>{t("navbar.try.contactCustomerService")}</span>
            </div>
          </div>
        </div>
      </Modal>

      {/* Add Call Name Modal */}
      <Modal
        isOpen={addCallNameModal}
        onRequestClose={handleCloseAddCallNameModal}
        className="selectedServiceModal w-[90%] md:w-[500px] max-w-[500px] mx-auto"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 999999,
          },
          content: {
            border: "none",
            borderRadius: "8px",
            padding: 0,
            margin: "0 auto",
          },
        }}
      >
        <div className="class50 w-full flex justify-end items-center px-4 py-3 bg-gradient-to-l shadow-md border-b bg-[#a070b9]">
          <span className="text-xl font-bold text-white">
            {t("navbar.try.addReferralId")}
          </span>
        </div>
        <div className="p-6">
          <p className="text-center text-gray-700 mb-4">
            {t("navbar.try.addReferralText")}
          </p>

          <div className="mb-4">
            <label
              htmlFor="callName"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              {t("navbar.try.referralId")}:
            </label>
            <input
              type="text"
              id="callName"
              className="px-3 py-2 bg-[#fcf6ff] outline-none border border-purple-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 text-center rounded-lg w-full transition-all duration-200"
              placeholder={t("navbar.try.usernameExample")}
              value={newCallNameInput}
              onChange={handleChange}
            />
            {error && (
              <div className="text-red-500 text-sm mt-2 bg-red-50 p-2 rounded">
                {error}
              </div>
            )}
          </div>

          <div className="bg-yellow-50 border border-yellow-200 p-3 rounded-md mb-5">
            <p className="text-sm text-yellow-800">
              <strong>{t("navbar.try.note")}:</strong> {t("navbar.try.note")}
            </p>
          </div>

          <div className="flex justify-end gap-3">
            <button
              className="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-md transition-colors duration-200"
              onClick={handleCloseAddCallNameModal}
            >
              {t("navbar.try.cancel")}
            </button>
            <button
              className="px-4 py-2 bg-purple-700 hover:bg-purple-800 text-white rounded-md transition-colors duration-200"
              onClick={handleSubmitAddCallName}
              disabled={!newCallNameInput.trim() || loading}
            >
              {loading ? (
                <span className="flex items-center">
                  <svg
                    className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  {t("navbar.try.saving")}
                </span>
              ) : (
                t("navbar.try.save")
              )}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Try;